import React from 'react'
import styled from '@emotion/styled'
import { Global, css } from '@emotion/core'
import { NumberInput, SelectMenu } from 'components/patterns/Inputs'
import { Paragraph } from 'components/patterns'
import { StyledFieldFooter } from 'components/patterns/Inputs/Field/Field.style'

export const StyledValue = styled(Paragraph)(
  (props) => `
  padding-left: 30px;
  color: ${props.theme.inputFontSecondaryColor};
`
)

export const StyledMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledSelectMenu = styled(SelectMenu)`
  width: 100%;

  .ant-select {
    width: ${({ narrow }) => (narrow ? '50%' : '100%')};
  }
  .ant-select-selection-selected-value {
    ${StyledValue} {
      display: none !important;
    }
  }
`

export const StyledNumberInput = styled(NumberInput)(
  ({ narrow }) => `
  width: ${narrow ? '50%' : '100%'};
  && .ant-input-number {
    width: 100px;
  }
  /* AB#455587: Put the footer back in document flow so the warning
     renders below the number input and shifts subsequent content down.
     Only applies when the footer has content (:not(:empty)), so the
     baseline layout (no warning, empty footer) is unchanged. */
  ${StyledFieldFooter}:not(:empty) {
    position: static;
    bottom: auto;
    margin-top: 2px;
  }
`
)

// Custom tooltip styles
export const customTooltipStyles = css`
  /* Tooltip bubble */
  .custom-tooltip .ant-tooltip-content {
    width: 355px !important;
  }
  /* Inner content of tooltip */
  .custom-tooltip .ant-tooltip-inner {
    height: 160px !important;
  }
`

// Global component to inject custom tooltip styles
export const CustomTooltipGlobalStyles = () => (
  <Global styles={customTooltipStyles} />
)
